const Helpers = {
    getUrlParam: function(url, parameter, defaultvalue) {
        var urlparameter = defaultvalue;
        var vars = {};
        var parts = url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        if(vars[parameter] !== undefined) {
            urlparameter = vars[parameter];
        }
        return urlparameter;
    }
};

export default Helpers;